"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
function SvgComponent(props) {
    const { fill = 'none' } = props, restProps = __rest(props, ["fill"]);
    return (react_1.default.createElement("svg", Object.assign({ "aria-hidden": 'true', focusable: 'false', className: `fl-${fill}`, width: 24, height: 24, viewBox: '0 0 24 24', xmlns: 'http://www.w3.org/2000/svg' }, restProps),
        react_1.default.createElement("path", { d: 'M9.64898 14.429L5.45289 11.0031C5.23872 10.8283 4.92305 10.8598 4.74783 11.0735L4.11327 11.8474C3.93804 12.0611 3.96961 12.3761 4.18378 12.5509L9.67845 17.037C9.88596 17.2064 10.1903 17.1828 10.3691 16.9834L18.8724 7.5001C19.0569 7.29432 19.0393 6.97825 18.833 6.79413L18.0863 6.12738C17.88 5.94326 17.5633 5.96082 17.3788 6.1666L9.99432 14.4022C9.90493 14.5019 9.75273 14.5137 9.64898 14.429Z' })));
}
exports.default = SvgComponent;
